import React from "react";

interface FormattedPhoneNumberProps {
    phone: string;
}

const FormattedPhoneNumber: React.FC<FormattedPhoneNumberProps> = ({ phone }) => {
    const formatPhoneNumber = (phone: string): string => {
        if (!phone) return "Número no disponible";

        const cleanedPhone = phone.replace(/\D/g, "");

        if (cleanedPhone.length === 8) {
            return `(502) ${cleanedPhone.slice(0, 4)} ${cleanedPhone.slice(4)}`;
        } else if (cleanedPhone.length === 11 && cleanedPhone.startsWith("502")) {
            return `(${cleanedPhone.slice(0, 3)}) ${cleanedPhone.slice(3, 7)} ${cleanedPhone.slice(7)}`;
        }

        return "Formato no válido";
    };

    return <span>{formatPhoneNumber(phone)}</span>;
};

export default FormattedPhoneNumber;
